import React from 'react';
import DraftEditor from './common/DraftEditor';
import { useResume } from '../context/ResumeContext';

const Affiliations = (props) => {
    const {
        resume: {
            affiliations,
            enabled_tabs
        },
        handlers: {
            updateResumePreview,
        },
    } = useResume();
    return (
        <div className="editor-form">
            <div className="form-row">
                <div className="field-wrap">
                    <DraftEditor
                        name="description"
                        className="validate"
                        value={affiliations.content}
                        //onChange={(e) => { props.updateJob({ description: e.target.value }, props.id) }}
                        onInputChange={(val) => {
                            updateResumePreview({
                                affiliations: { ...affiliations, content: val },
                                current_tab: 'additional_sections',
                                
                            });
                        }}
                    />
                </div>
            </div>
        </div>);
}

export default Affiliations;